const KPCart = {

    drawer: null,
    overlay: null,
    items: null,
    empty: null,
    subtotal: null,
    counter: null,
    cart: null,

    init() {

        this.drawer = document.getElementById("KPCartDrawer");
        this.overlay = document.getElementById("KPCartOverlay");
        this.items = document.getElementById("KPCartItems");
        this.empty = document.getElementById("KPCartEmpty");
        this.subtotal = document.getElementById("KPCartSubtotal");
        this.counter = document.getElementById("KPCartCount");

        if (!this.drawer) return;

        this.bindBaseEvents();

        this.load();

    },

    bindBaseEvents() {

        const close = document.getElementById("KPCartClose");
        const cartButton = document.getElementById("KPCartButton");

        if (close) {

            close.addEventListener("click", () => {

                this.close();

            });

        }

        if (this.overlay) {

            this.overlay.addEventListener("click", () => {

                this.close();

            });

        }
        if (cartButton) {

    cartButton.addEventListener("click", () => {

        this.load();

        this.open();

    });

}

        document.addEventListener("keydown", (event) => {

            if (event.key === "Escape") {

                this.close();

            }

        });

    },

    open() {

        this.drawer.classList.add("is-open");
        this.overlay.classList.add("is-open");
        this.drawer.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";

    },

    close() {

        this.drawer.classList.remove("is-open");
        this.overlay.classList.remove("is-open");
        this.drawer.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";

    },

    async load() {

        try {

            const response = await fetch("/cart.js");

            this.cart = await response.json();

            this.render();

        }

        catch (error) {

            console.error(error);

        }

    },

    formatMoney(cents) {

        return new Intl.NumberFormat("es-CO", {

            style: "currency",

            currency: "COP",

            maximumFractionDigits: 0

        }).format(cents / 100);

    },

    render() {

        if (!this.cart) return;

        this.counter.textContent = this.cart.item_count;

        const headerCounter = document.getElementById("KPHeaderCartCount");

if (headerCounter) {

    headerCounter.textContent = this.cart.item_count;

}

        this.subtotal.textContent = this.formatMoney(this.cart.total_price);

        if (this.cart.item_count === 0) {

            this.items.innerHTML = "";

            this.items.hidden = true;

            this.empty.hidden = false;

            return;

        }

        this.items.hidden = false;

        this.empty.hidden = true;

        this.items.innerHTML = this.cart.items.map(item => `

<div class="kp-cart-product" data-key="${item.key}">

    <a
        href="${item.url}"
        class="kp-cart-product-image">

        <img
            src="${item.image}"
            alt="${item.product_title}">

    </a>

    <div class="kp-cart-product-info">

        <a
            href="${item.url}"
            class="kp-cart-product-title">

            ${item.product_title}

        </a>

        ${item.variant_title && item.variant_title !== "Default Title"
            ? `<div class="kp-cart-product-variant">${item.variant_title}</div>`
            : ""}

        <div class="kp-cart-product-price">

            ${this.formatMoney(item.final_price)}

        </div>

        <div class="kp-cart-product-footer">

            <div
                class="kp-cart-quantity"
                data-key="${item.key}">

                <button
                    type="button"
                    class="kp-cart-minus">

                    −

                </button>

                <input
                    type="text"
                    value="${item.quantity}"
                    readonly>

                <button
                    type="button"
                    class="kp-cart-plus">

                    +

                </button>

            </div>

            <button
                type="button"
                class="kp-cart-remove"
                data-key="${item.key}">

                Eliminar

            </button>

        </div>

    </div>

</div>

`).join("");

        this.bindCartEvents();

    },

    bindCartEvents() {

        this.items.querySelectorAll(".kp-cart-plus").forEach(button => {

            button.addEventListener("click", () => {

                const key = button
                    .closest(".kp-cart-quantity")
                    .dataset.key;

                this.changeQuantity(key, 1);

            });

        });

        this.items.querySelectorAll(".kp-cart-minus").forEach(button => {

            button.addEventListener("click", () => {

                const key = button
                    .closest(".kp-cart-quantity")
                    .dataset.key;

                this.changeQuantity(key, -1);

            });

        });

        this.items.querySelectorAll(".kp-cart-remove").forEach(button => {

            button.addEventListener("click", () => {

                this.remove(button.dataset.key);

            });

        });

    },
        async changeQuantity(key, delta) {

        const item = this.cart.items.find(product => product.key === key);

        if (!item) return;

        let quantity = item.quantity + delta;

        if (quantity < 0) {

            quantity = 0;

        }

        await this.update(key, quantity);

    },

    async remove(key) {

        await this.update(key, 0);

    },

    async update(key, quantity) {

        try {

            const response = await fetch("/cart/change.js", {

                method: "POST",

                headers: {

                    "Content-Type": "application/json"

                },

                body: JSON.stringify({

                    id: key,
                    quantity: quantity

                })

            });

            if (!response.ok) {

                throw new Error("No fue posible actualizar el carrito.");

            }

            await this.load();

        }

        catch (error) {

            console.error("KP Cart:", error);

        }

    },

    async add(form) {

        try {

            const formData = new FormData(form);

            const response = await fetch("/cart/add.js", {

                method: "POST",

                body: formData

            });

            if (!response.ok) {

                throw new Error("No fue posible añadir el producto.");

            }

            await this.load();

            this.open();

        }

        catch (error) {

            console.error("KP Cart:", error);

        }

    },

    bindProductForms() {

        document.querySelectorAll('form[action*="/cart/add"], #KPProductForm').forEach(form => {

            form.addEventListener("submit", async (event) => {

                event.preventDefault();

                await this.add(form);

            });

        });

    }

};

document.addEventListener("DOMContentLoaded", function () {

    KPCart.init();

    KPCart.bindProductForms();

});
